export const uk = {
    more: 'еще'
};
